<h1 mat-dialog-title>Change Carrier</h1>
<div mat-dialog-content>
  <form [formGroup]="newCarrierInfoForm">
    <mat-form-field style="width: 100%;">
      <mat-label>New Carrier</mat-label>
      <input
        type="text"
        matInput
        formControlName="new_carrier_control"
        [matAutocomplete]="auto"
        placeholder="Type at least 3 letters"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayFn"
        (optionSelected)="onCarrierSelected($event.option.value)"
      >
        <mat-option *ngFor="let carrier of filteredCarrierList | async" [value]="carrier">
          {{ carrier.label }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button color="primary" (click)="onSubmit()">Submit</button>
</div>